module.exports = __webpack_public_path__ + "static/2-ee52331354c07100c2417784fdd3f0f4.png";